import axios from '../../../api/axiosInstance';

export const FETCH_PROMOTION_PACKAGES_SUCCESS = 'FETCH_PROMOTION_PACKAGES_SUCCESS';
export const FETCH_MY_PROMOTIONS_SUCCESS = 'FETCH_MY_PROMOTIONS_SUCCESS';
export const PROMOTION_LOADING = 'PROMOTION_LOADING';
export const PROMOTION_ERROR = 'PROMOTION_ERROR';

export const FETCH_AVAILABLE_SPACES_SUCCESS = 'FETCH_AVAILABLE_SPACES_SUCCESS';
export const CLEAR_AVAILABLE_SPACES = 'CLEAR_AVAILABLE_SPACES';

export const fetchAvailableHostSpaces = (hostEmail, packageId = null) => async (dispatch) => {
    dispatch({ type: CLEAR_AVAILABLE_SPACES });
    dispatch({ type: PROMOTION_LOADING });
    try {
        const url = `space/host-promotions/available-spaces/${hostEmail}${packageId ? `?packageId=${packageId}` : ''}`;
        const response = await axios.get(url);
        dispatch({ type: FETCH_AVAILABLE_SPACES_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: PROMOTION_ERROR, payload: error.message });
    }
};

export const fetchActivePackages = () => async (dispatch) => {
    dispatch({ type: PROMOTION_LOADING });
    try {
        const response = await axios.get('space/promotion-packages/active');
        dispatch({ type: FETCH_PROMOTION_PACKAGES_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: PROMOTION_ERROR, payload: error.message });
    }
};

export const fetchMyPromotions = (hostId) => async (dispatch) => {
    dispatch({ type: PROMOTION_LOADING });
    try {
        const response = await axios.get(`space/host-promotions/host/${hostId}`);
        dispatch({ type: FETCH_MY_PROMOTIONS_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: PROMOTION_ERROR, payload: error.message });
    }
};

export const initiatePromotionPurchase = (bookingData) => async (dispatch) => {
    try {
        const response = await axios.post('space/host-promotions/purchase', bookingData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updatePromotionPayment = (bookingId, status, paymentRef) => async (dispatch) => {
    try {
        const response = await axios.put(`space/host-promotions/${bookingId}/payment-status`, null, {
            params: { status, paymentRef }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const FETCH_PROMOTION_ANALYTICS_SUCCESS = 'FETCH_PROMOTION_ANALYTICS_SUCCESS';

export const fetchPromotionAnalytics = (id) => async (dispatch) => {
    dispatch({ type: PROMOTION_LOADING });
    try {
        const response = await axios.get(`space/host-promotions/${id}/analytics`);
        dispatch({ type: FETCH_PROMOTION_ANALYTICS_SUCCESS, payload: response.data });
        return response.data;
    } catch (error) {
        dispatch({ type: PROMOTION_ERROR, payload: error.message });
        return null;
    }
};
